/* ============================================================
   KORLAÏ — runtime Nocturne
   Favoris, réservation panier,
   compte à rebours du drop, toasts.
   Vanilla, sans dépendance. Chargé en `defer`.
   ============================================================ */

(function () {
  'use strict';

  var STORE_FAVS = 'korlai:favs';
  var STORE_RESERVATION = 'korlai:reservation';
  var STORE_SIZE = 'korlai:taille';
  var RESERVATION_MINUTES = 30;

  var $ = function (sel, root) {
    return (root || document).querySelector(sel);
  };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ---------- Stockage tolérant (mode privé, quota plein) ---------- */

  function readStore(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeStore(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* silencieux : le site reste utilisable sans persistance */
    }
  }

  // Ces deux fonctions sont enfermées dans l'IIFE : un <script> de section qui
  // les appellerait échouerait en ReferenceError silencieux — la préférence
  // paraîtrait retenue à l'écran et serait perdue à la page suivante. Un seul
  // export, et surtout pas un localStorage.setItem direct : le try/catch
  // ci-dessus (navigation privée, quota plein) est toute leur raison d'être.
  window.korlaiPrefs = { read: readStore, write: writeStore };

  /* ---------- Toast ---------- */

  function toast(message) {
    var host = $('[data-k-toast-host]');
    if (!host || !message) return;

    var el = document.createElement('div');
    el.className = 'k-toast';
    el.textContent = message;
    host.appendChild(el);

    window.setTimeout(function () {
      el.style.transition = 'opacity .2s ease';
      el.style.opacity = '0';
      window.setTimeout(function () {
        el.remove();
      }, 220);
    }, 2200);
  }

  window.korlaiToast = toast;

  /* ---------- Formats ---------- */

  function money(cents) {
    var value = (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return value + ' €';
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* ============================================================
     1. Favoris (localStorage — en attendant le compte client)
     ============================================================ */

  function getFavs() {
    var favs = readStore(STORE_FAVS, []);
    return Array.isArray(favs) ? favs : [];
  }

  function isFav(id) {
    return getFavs().indexOf(String(id)) !== -1;
  }

  function toggleFav(id) {
    id = String(id);
    var favs = getFavs();
    var idx = favs.indexOf(id);
    var added = idx === -1;

    if (added) {
      favs.push(id);
    } else {
      favs.splice(idx, 1);
    }
    writeStore(STORE_FAVS, favs);

    document.dispatchEvent(new CustomEvent('korlai:favs', { detail: { id: id, added: added } }));
    return added;
  }

  window.korlaiFavs = { get: getFavs, has: isFav, toggle: toggleFav };

  function paintFav(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
    btn.setAttribute('aria-label', label);
    var icon = btn.querySelector('.k-i');
    if (icon) icon.setAttribute('data-state', active ? 'fill' : 'regular');
  }

  function initFavs() {
    $$('[data-k-fav]').forEach(function (btn) {
      var id = btn.getAttribute('data-k-fav');
      paintFav(btn, isFav(id));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggleFav(id);
        paintFav(btn, added);
        toast(added ? 'Ajoutée aux favoris — alerte prix active' : 'Retirée des favoris');
      });
    });

    // Synchronise les autres boutons pointant sur la même pièce
    document.addEventListener('korlai:favs', function (e) {
      $$('[data-k-fav="' + e.detail.id + '"]').forEach(function (btn) {
        paintFav(btn, e.detail.added);
      });
    });
  }

  /* ============================================================
     2. Panier — ajout AJAX + réservation 30 min
     ============================================================ */

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        $$('[data-k-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        if (cart.item_count === 0) {
          clearReservation();
        } else {
          ensureReservation();
        }
        return cart;
      })
      .catch(function () {
        /* le badge garde sa valeur serveur */
      });
  }

  function ensureReservation() {
    var deadline = readStore(STORE_RESERVATION, null);
    var now = Date.now();
    if (!deadline || deadline < now) {
      deadline = now + RESERVATION_MINUTES * 60 * 1000;
      writeStore(STORE_RESERVATION, deadline);
    }
    return deadline;
  }

  function clearReservation() {
    try {
      window.localStorage.removeItem(STORE_RESERVATION);
    } catch (e) {
      /* rien à faire */
    }
  }

  function initAddToCart() {
    $$('[data-k-add-to-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Réservation…';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: form.dataset.variantId, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
          })
          .then(function () {
            ensureReservation();
            return refreshCartCount();
          })
          .then(function () {
            toast('Pièce réservée ' + RESERVATION_MINUTES + ' min — elle vous attend au panier.');
            // La fiche bascule sur l'état accompli
            var wrap = form.closest('[data-k-cta-wrap]');
            if (wrap) {
              wrap.innerHTML =
                '<a href="/cart" class="k-btn k-btn--done k-btn--lg">Dans le panier — voir</a>';
            } else if (btn) {
              btn.innerHTML = original;
              btn.disabled = false;
            }
          })
          .catch(function () {
            toast('Cette pièce vient de partir. Elle n\'est plus disponible.');
            if (btn) {
              btn.innerHTML = original;
              btn.disabled = false;
            }
          });
      });
    });
  }

  function initReservationTimer() {
    var displays = $$('[data-k-reservation]');
    if (!displays.length) return;

    var deadline = readStore(STORE_RESERVATION, null);
    if (!deadline) {
      deadline = ensureReservation();
    }

    var expired = false;

    function tick() {
      var left = deadline - Date.now();

      if (left <= 0 && !expired) {
        expired = true;
        // Pièces uniques : la réservation tombe, le panier est libéré
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            toast('Réservation expirée — les pièces sont de nouveau en ligne.');
            window.setTimeout(function () {
              window.location.reload();
            }, 1800);
          })
          .catch(function () {
            toast('Réservation expirée.');
          });
        return;
      }

      var total = Math.max(0, Math.floor(left / 1000));
      var text = pad(Math.floor(total / 60)) + ':' + pad(total % 60);
      displays.forEach(function (el) {
        el.textContent = text;
      });
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initRemoveFromCart() {
    $$('[data-k-cart-remove]').forEach(function (el) {
      el.addEventListener('click', function () {
        toast('Pièce libérée — de nouveau en ligne.');
      });
    });
  }

  /* ============================================================
     3. Compte à rebours du drop programmé
     ============================================================ */

  // Le drop n'est pas hebdomadaire : l'app programme UN drop, et le thème
  // rend son début et sa fin d'ouverture en millisecondes sur chaque racine
  // (snippets/korlai-drop-root.liquid). Passé la fin, tout ce qui l'annonce
  // s'efface — pastille, carte, liens, compte à rebours — et « aucun drop
  // programmé » revient, sans attendre un nouveau rendu de la page.
  // `style.display` plutôt que `hidden` : une classe qui pose `display` bat
  // l'attribut en silence (le lien d'en-tête, le compte à rebours).
  function dropOver() {
    $$('[data-k-drop-when="on"]').forEach(function (el) { el.style.display = 'none'; });
    $$('[data-k-drop-when="off"]').forEach(function (el) {
      el.hidden = false;
      el.style.display = '';
    });
  }

  function initDropCountdown() {
    var roots = $$('[data-k-drop]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      // init() est rejoué à chaque shopify:section:load, y compris pour une
      // AUTRE section : sans ce drapeau, chaque rechargement dans l'éditeur
      // empilait un setInterval de plus sur la même racine.
      if (root.getAttribute('data-k-drop-ready') === '1') return;
      root.setAttribute('data-k-drop-ready', '1');

      var target = parseInt(root.getAttribute('data-k-drop-at') || '0', 10);
      // Fin de la fenêtre pendant laquelle on annonce « c'est ouvert » : le
      // seul instant que toute la mécanique prépare doit être représenté.
      var until = parseInt(root.getAttribute('data-k-drop-until') || '0', 10);
      if (!target) return;

      var dEl = $('[data-k-drop-d]', root);
      var dCell = dEl ? dEl.parentNode : null;
      var hEl = $('[data-k-drop-h]', root);
      var mEl = $('[data-k-drop-m]', root);
      var sEl = $('[data-k-drop-s]', root);
      var shortEl = $('[data-k-drop-short]', root);

      var timer = null;

      function tick() {
        var now = Date.now();
        var left = target - now;

        if (left <= 0) {
          if (now < until) {
            // Le drop est ouvert : on le DIT, on ne recompte pas.
            root.classList.add('is-open');
            if (shortEl) shortEl.textContent = "c'est ouvert";
            if (dCell) dCell.hidden = true;
            if (hEl) hEl.textContent = '00';
            if (mEl) mEl.textContent = '00';
            if (sEl) sEl.textContent = '00';
            return;
          }
          // Fenêtre refermée : pas de « semaine suivante », le drop suivant
          // se programme dans l'app.
          root.classList.remove('is-open');
          window.clearInterval(timer);
          dropOver();
          return;
        }

        var totalSec = Math.floor(left / 1000);
        var d = Math.floor(totalSec / 86400);
        // Sans le modulo, la case « h » affichait le total — donc « 167 »
        // dans un encadré de 84 px, juste après un drop.
        var h = Math.floor(totalSec / 3600) % 24;
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;

        if (dCell) dCell.hidden = d === 0;
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
        if (shortEl) {
          shortEl.textContent = d > 0 ? d + ' j' : (h > 0 ? h + ' h' : m + ' min');
        }
      }

      timer = window.setInterval(tick, 1000);
      tick();
    });
  }


  /* ============================================================
     4. Copie du numéro de suivi
     ============================================================ */

  function initCopy() {
    $$('[data-k-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-k-copy');
        if (!navigator.clipboard) {
          toast('Copie indisponible sur ce navigateur.');
          return;
        }
        navigator.clipboard
          .writeText(value)
          .then(function () {
            toast('N° de suivi copié');
          })
          .catch(function () {
            toast('Copie impossible.');
          });
      });
    });
  }

  /* ============================================================
     Hero — vitrine tournante (aujourd'hui : les tenues)

     ⚠️ Le préfixe `data-k-uni-*` est HISTORIQUE : le hero montrait les
     univers, il montre désormais des tenues. Les attributs n'ont pas été
     renommés pour ne pas toucher au contrat DOM déjà déployé ; la
     mécanique, elle, est indifférente à ce qu'elle fait défiler.

     Le dernier mot du titre bascule comme un volet, le visuel fond vers
     celui de la tenue appelée, et c'est le SÉLECTEUR qui se remplit.

     La barre du sélecteur EST le minuteur : c'est la fin de son
     animation qui fait avancer, pas un setInterval parallèle. Sans ça,
     la pause au survol arrête la barre mais pas le compteur, et les
     deux se désynchronisent dès le premier survol.

     Les couches déjà vues restent visibles dessous : en fondu, laisser
     l'ancienne disparaître en même temps que la nouvelle apparaît
     ferait passer le fond du cadre à travers à mi-course.
     ============================================================ */

  function initHeroShowcase() {
    $$('[data-k-uni]').forEach(function (root) {
      // init() est rejoué à chaque shopify:section:load, y compris pour
      // une AUTRE section : sans ce drapeau on empilerait les minuteurs.
      if (root.getAttribute('data-k-uni-ready') === '1') return;
      root.setAttribute('data-k-uni-ready', '1');

      var layers = $$('[data-k-uni-layer]', root);
      if (layers.length < 2) return;

      var tabs = $$('[data-k-uni-tab]', root);
      var rail = $('.k-hero__rail', root);
      var word = $('[data-k-uni-word]', root);
      var meta = $('[data-k-uni-meta]', root);
      var cta = $('[data-k-uni-cta]', root);
      var ctaLabel = cta ? (cta.textContent || '').trim() : '';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var auto = !reduce.matches && tabs.length === layers.length;
      var current = 0;
      var z = layers.length;
      var wordTimer = 0;
      var wordWanted = word ? (word.textContent || '') : '';

      function setWord(label) {
        // On compare au dernier libellé DEMANDÉ, pas à celui AFFICHÉ.
        // Pendant les 190 ms de la bascule, l'affiché est encore l'ancien :
        // comparer à lui ferait sortir un second appel en `return`, et le
        // timer précédent écrirait ensuite un univers qui n'est plus le
        // courant — titre d'un côté, visuel et onglet de l'autre.
        if (!word || !label || wordWanted === label) return;
        wordWanted = label;
        window.clearTimeout(wordTimer);
        if (reduce.matches) {
          word.textContent = label;
          return;
        }
        word.style.transform = 'translateY(-105%)';
        word.style.opacity = '0';
        wordTimer = window.setTimeout(function () {
          word.textContent = label;
          word.style.transition = 'none';
          word.style.transform = 'translateY(105%)';
          void word.offsetWidth; // reflow : sinon les deux états sont fusionnés
          word.style.transition = '';
          word.style.transform = 'translateY(0)';
          word.style.opacity = '1';
        }, 190);
      }

      function reveal(i) {
        var layer = layers[i];
        layer.style.transition = 'none';
        layer.classList.remove('is-on');
        void layer.offsetWidth; // rejoue le fondu même sur un univers déjà vu
        layer.style.transition = '';
        layer.style.zIndex = ++z;
        layer.classList.add('is-on');
      }

      // Échelle atteinte par le remplissage, lue sur le pseudo-élément :
      // le retrait doit repartir de là où la barre en est vraiment.
      function scaleOf(tab) {
        var t = window.getComputedStyle(tab, '::after').transform;
        if (!t || t === 'none') return 1;
        var m = /matrix\(\s*([-\d.eE+]+)/.exec(t);
        return m ? parseFloat(m[1]) : 1;
      }

      function paintTabs(i) {
        tabs.forEach(function (tab, j) {
          var on = j === i;
          tab.classList.toggle('is-on', on);
          tab.setAttribute('aria-pressed', on ? 'true' : 'false');

          if (on) {
            tab.classList.remove('is-draining', 'is-full', 'is-filling');
            void tab.offsetWidth;
            tab.classList.add(auto ? 'is-filling' : 'is-full');
            return;
          }

          if (!tab.classList.contains('is-filling') && !tab.classList.contains('is-full')) return;
          tab.style.setProperty('--k-uni-from', String(scaleOf(tab)));
          tab.classList.remove('is-filling', 'is-full', 'is-draining');
          void tab.offsetWidth;
          tab.classList.add('is-draining');
        });
      }

      function go(i) {
        if (i === current) return;
        current = i;
        reveal(i);

        var tab = tabs[i];
        var label = tab ? tab.getAttribute('data-k-uni-label') : '';
        var url = tab ? tab.getAttribute('data-k-uni-url') : '';
        setWord(label);
        if (meta) meta.textContent = tab ? tab.getAttribute('data-k-uni-meta') || '' : '';
        paintTabs(i);
        showTab(i);

        if (cta && url) {
          cta.setAttribute('href', url);
          cta.setAttribute('aria-label', ctaLabel + ' — ' + label);
        }
      }

      // Ramène l'onglet actif dans le champ : à 5 univers le rail déborde
      // sur téléphone, et l'onglet actif — donc la barre qui se remplit —
      // peut être entièrement hors écran, sans ascenseur pour le dire.
      // On fait défiler le RAIL seul : scrollIntoView remonterait jusqu'au
      // document, et la page se remettrait à bouger toute seule toutes les
      // six secondes.
      function showTab(i) {
        if (!rail || !tabs[i] || rail.scrollWidth <= rail.clientWidth) return;
        var tab = tabs[i];
        var left = tab.offsetLeft - (rail.clientWidth - tab.offsetWidth) / 2;
        if (!rail.scrollTo) {
          rail.scrollLeft = Math.max(0, left);
          return;
        }
        rail.scrollTo({
          left: Math.max(0, left),
          behavior: reduce.matches ? 'auto' : 'smooth'
        });
      }

      // La barre est le minuteur : sa fin fait avancer. Les événements
      // d'animation d'un pseudo-élément remontent sur l'élément porteur.
      root.addEventListener('animationend', function (e) {
        if (!auto || e.animationName !== 'k-uni-fill') return;
        go((current + 1) % layers.length);
      });

      tabs.forEach(function (tab, j) {
        tab.addEventListener('click', function () {
          auto = false; // le visiteur a choisi : on ne le déplace plus tout seul
          if (j === current) {
            paintTabs(j); // fige la barre au lieu de la laisser courir
            return;
          }
          go(j);
        });
      });

      // Deux sources indépendantes de pause. Un seul booléen partagé
      // laisserait la souris décider pour le clavier : sortir le pointeur
      // du hero relancerait la rotation alors que le focus est encore sur
      // un onglet, et l'univers changerait sous l'élément focalisé.
      var hovered = false;
      var focused = false;
      function pause() {
        root.classList.toggle('is-paused', hovered || focused);
      }

      // Le survol n'est écouté que sur un pointeur qui survole vraiment.
      // Sur iOS un tap synthétise mouseenter et le « hover collant » ne
      // rend jamais la main : la barre resterait figée, et comme elle est
      // désormais la seule horloge, le hero ne basculerait plus jamais.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        root.addEventListener('mouseenter', function () {
          hovered = true;
          pause();
        });
        root.addEventListener('mouseleave', function () {
          hovered = false;
          pause();
        });
      }

      root.addEventListener('focusin', function () {
        focused = true;
        pause();
      });
      root.addEventListener('focusout', function (e) {
        // focusout précède le focusin suivant : sans ce test, passer d'un
        // onglet au voisin relancerait le remplissage le temps d'une frame.
        focused = !!(e.relatedTarget && root.contains(e.relatedTarget));
        pause();
      });

      paintTabs(0);
      showTab(0);
    });
  }

  /* ============================================================
     Accueil — votre taille (règle de tailleur)

     La taille choisie est mémorisée d'une page à l'autre. Une taille
     mémorisée qui n'est plus proposée n'allume rien : mieux vaut aucun
     cran retenu qu'un cran retenu qui ne mène nulle part.
     ============================================================ */

  function initTaille() {
    $$('[data-k-taille]').forEach(function (root) {
      if (root.getAttribute('data-k-taille-ready') === '1') return;
      root.setAttribute('data-k-taille-ready', '1');

      var chips = $$('[data-k-taille-chip]', root);
      if (!chips.length) return;

      // Clé scopée : l'accueil porte DEUX règles (vêtements et pointures).
      // Avec une clé commune, choisir une pointure effacerait la taille de
      // vêtement du visiteur — et inversement.
      var storeKey = STORE_SIZE + ':' + (root.getAttribute('data-k-taille-store') || 'taille');

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var readout = $('[data-k-dial-readout]', root);
      var lens = $('[data-k-dial-lens]', root);
      var cta = $('[data-k-dial-cta]', root);
      // Le cran sous l'aiguille. Distinct du cran RETENU (mémorisé, souligné) :
      // lire n'est pas choisir, on ne mémorise qu'au clic — sinon un simple
      // défilement réécrirait la préférence.
      var read = null;

      function paint(value) {
        chips.forEach(function (chip) {
          var on = !!value && chip.getAttribute('data-k-taille-value') === value;
          chip.classList.toggle('is-active', on);
          if (on) {
            chip.setAttribute('aria-current', 'true');
          } else {
            chip.removeAttribute('aria-current');
          }
        });
      }

      function choose(chip) {
        var value = chip.getAttribute('data-k-taille-value');
        writeStore(storeKey, value);
        paint(value);
        document.dispatchEvent(
          new CustomEvent('korlai:taille', { detail: { key: storeKey, value: value } })
        );
      }

      // Lecture du cran centré : la loupe le répète en grand, la ligne de
      // lecture dit ce qu'il y a, le bouton y mène. Construit en nœuds, pas en
      // innerHTML : le libellé vient de l'éditeur.
      function readCentre(track) {
        if (!track) return;
        var notches = $$('.k-dial__notch', track);
        if (!notches.length) return;
        var centre = track.scrollLeft + track.clientWidth / 2;
        var best = null;
        var bestGap = Infinity;
        notches.forEach(function (n) {
          var gap = Math.abs(n.offsetLeft + n.offsetWidth / 2 - centre);
          if (gap < bestGap) { bestGap = gap; best = n; }
        });
        if (!best) return;
        read = best;
        notches.forEach(function (n) { n.classList.toggle('is-read', n === best); });

        var label = best.getAttribute('data-k-taille-value') || '';
        var count = parseInt(best.getAttribute('data-k-dial-count') || '0', 10);
        if (lens) lens.textContent = label;
        if (readout) {
          readout.textContent = '';
          var b = document.createElement('b');
          b.textContent = label;
          readout.appendChild(b);
          readout.appendChild(document.createTextNode(
            count > 0
              ? count + ' pièce' + (count > 1 ? 's' : '') + ' en ligne'
              : 'rien pour l’instant'
          ));
        }
        if (cta) {
          if (count > 0) {
            cta.href = best.getAttribute('href');
            cta.textContent = count > 1 ? 'Voir les ' + count + ' pièces →' : 'Voir la pièce →';
            cta.classList.remove('is-ghost');
          } else {
            cta.href = cta.getAttribute('data-k-dial-all');
            cta.textContent = 'Toutes les pièces →';
            cta.classList.add('is-ghost');
          }
          cta.hidden = false;
        }
      }

      function centre(track, notch, instant) {
        if (!track || !notch) return;
        var left = notch.offsetLeft + notch.offsetWidth / 2 - track.clientWidth / 2;
        // `scrollTo` avec behavior explicite : le scroll-behavior CSS ne
        // neutralise pas un 'smooth' passé en argument.
        var now = instant || reduce.matches;
        if (track.scrollTo) {
          track.scrollTo({ left: Math.max(0, left), behavior: now ? 'auto' : 'smooth' });
        } else {
          track.scrollLeft = Math.max(0, left);
          now = true;
        }
        // Un saut instantané se relit tout de suite : on n'attend pas un
        // `scroll` qui ne vient pas quand la règle est déjà en place. Le
        // défilement fluide, lui, se relit au fil de ses événements.
        if (now) readCentre(track);
      }

      function visibleTrack() {
        var tracks = $$('[data-k-dial-track]', root);
        for (var i = 0; i < tracks.length; i++) {
          if (!tracks[i].hidden) return tracks[i];
        }
        return tracks[0] || null;
      }

      $$('[data-k-dial-track]', root).forEach(function (track) {
        // Une molette VERTICALE ne fait pas défiler un conteneur horizontal :
        // sans traduction du geste, tourner la roulette au-dessus de la règle
        // faisait défiler la page et la règle ne bougeait pas.
        track.addEventListener('wheel', function (e) {
          if (track.scrollWidth <= track.clientWidth) return;
          var delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
          if (!delta) return;
          // On ne confisque la roulette QUE tant qu'il reste de la course :
          // arrivé en bout, on rend la main à la page, sinon le curseur posé
          // sur la règle bloquerait le défilement du site.
          var max = track.scrollWidth - track.clientWidth;
          var next = track.scrollLeft + delta;
          if ((delta < 0 && track.scrollLeft <= 0) || (delta > 0 && track.scrollLeft >= max - 1)) {
            return;
          }
          e.preventDefault();
          track.scrollLeft = Math.max(0, Math.min(max, next));
        }, { passive: false });

        var pending = false;
        track.addEventListener('scroll', function () {
          if (pending) return;
          pending = true;
          window.requestAnimationFrame(function () {
            pending = false;
            readCentre(track);
          });
        });
      });

      // Changement d'échelle : une seule piste visible, et on relit son centre.
      $$('[data-k-dial-scale]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wanted = btn.getAttribute('data-k-dial-scale');
          $$('[data-k-dial-scale]', root).forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          $$('[data-k-dial-track]', root).forEach(function (t) {
            t.hidden = t.getAttribute('data-k-dial-track') !== wanted;
          });
          readCentre(visibleTrack());
        });
      });

      // Flèches (souris) : une taille de plus ou de moins sous l'aiguille.
      $$('[data-k-dial-step]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var track = visibleTrack();
          if (!track) return;
          var notches = $$('.k-dial__notch', track);
          var i = notches.indexOf(read);
          var next = notches[(i < 0 ? 0 : i) + parseInt(btn.getAttribute('data-k-dial-step'), 10)];
          if (next) centre(track, next);
        });
      });

      chips.forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          choose(chip);
          // Un cran qui n'est pas sous l'aiguille y VIENT d'abord : le premier
          // clic choisit la taille, le bouton (ou un second clic) ouvre sa
          // collection. Sans JS, le lien y mène directement.
          if (chip !== read) {
            e.preventDefault();
            centre(chip.parentNode, chip);
          }
        });
        // Au clavier, atteindre un cran doit l'amener sous l'aiguille : sinon
        // la tabulation traverse une règle qui ne bouge pas.
        chip.addEventListener('focus', function () {
          centre(chip.parentNode, chip);
        });
      });

      if (cta) {
        cta.addEventListener('click', function () {
          if (read) choose(read);
        });
      }

      var stored = readStore(storeKey, null);
      paint(stored);

      // On ouvre sur la taille retenue si elle est encore proposée, et on la
      // met sous l'aiguille — sinon la règle s'ouvre au premier cran.
      var start = null;
      if (stored) {
        chips.forEach(function (c) {
          if (!start && c.getAttribute('data-k-taille-value') === stored) start = c;
        });
      }
      if (start) {
        var owner = start.parentNode;
        $$('[data-k-dial-scale]', root).forEach(function (b) {
          var on = b.getAttribute('data-k-dial-scale') === owner.getAttribute('data-k-dial-track');
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $$('[data-k-dial-track]', root).forEach(function (t) { t.hidden = t !== owner; });
        centre(owner, start, true);
      }
      readCentre(visibleTrack());
    });
  }

  /* ============================================================
     Gravure des portes — l'encre au doigt (sections/korlai-portes)
     ============================================================ */

  // Sur souris, le creux d'une porte gravée s'encre au SURVOL (CSS).
  // Un téléphone n'a pas de survol, or c'est là que se fait l'essentiel
  // du trafic : la porte s'encre quand elle passe au MILIEU de l'écran et
  // se vide quand elle en sort. En faisant défiler, Neuf puis Occasion
  // s'encrent chacun à son tour — la porte qu'on regarde est celle qui
  // est encrée, comme celle qu'on survole sur ordinateur.
  // Réservé à `(hover: none)` : sur un écran tactile AVEC souris, le
  // survol fait déjà le travail, et les deux se contrediraient.
  var graveObserver = null;

  function initGrave() {
    if (!('IntersectionObserver' in window)) return;
    if (!window.matchMedia('(hover: none)').matches) return;
    if (!graveObserver) {
      // Une LIGNE au milieu de l'écran (4 % de sa hauteur), pas une zone :
      // les deux bandeaux se touchent et font 188 px sur téléphone. Une
      // zone de 30 % (244 px) contenait presque toujours leur frontière, et
      // les deux s'encraient ensemble — mesuré le 18/10.
      graveObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-encre', entry.isIntersecting);
        });
      }, { rootMargin: '-48% 0px -48% 0px', threshold: 0 });
    }
    // init() est rejoué à chaque shopify:section:load : une porte déjà
    // observée ne l'est pas deux fois.
    $$('.k-porte--grave:not([data-k-encre])').forEach(function (porte) {
      porte.setAttribute('data-k-encre', '');
      graveObserver.observe(porte);
    });
  }

  /* ============================================================
     Fondu des photos à leur arrivée
     Une image DÉJÀ chargée ne passe jamais par l'opacité 0 : seule celle
     qui arrive après le script (paresseuse, réseau lent) est masquée, puis
     révélée au `load`. Une erreur la révèle aussi — un texte alternatif
     vaut mieux qu'un trou. Réglage visuel : `.is-k-chargement` dans
     korlai-nocturne.css.
     ============================================================ */

  function initFondu() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('.k-card__media img, .k-porte__img').forEach(function (img) {
      if (img.complete || img.hasAttribute('data-k-fondu')) return;
      img.setAttribute('data-k-fondu', '');
      img.classList.add('is-k-chargement');
      var reveler = function () { img.classList.remove('is-k-chargement'); };
      img.addEventListener('load', reveler, { once: true });
      img.addEventListener('error', reveler, { once: true });
    });
  }

  /* ============================================================
     Démarrage
     ============================================================ */

  function init() {
    initFavs();
    initAddToCart();
    initReservationTimer();
    initRemoveFromCart();
    initDropCountdown();
    initHeroShowcase();
    initTaille();
    initCopy();
    initGrave();
    initFondu();
  }

  // iOS n'applique la pseudo-classe :active (l'enfoncement à l'appui, voir
  // le bloc APPUI de korlai-nocturne.css) que si un écouteur `touchstart`
  // existe. Vide et passif : il ne retarde ni le défilement ni le tap.
  document.addEventListener('touchstart', function () {}, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // L'éditeur de thème recharge les sections à chaud
  document.addEventListener('shopify:section:load', init);
})();
